import { render, staticRenderFns } from "./RolesView.vue?vue&type=template&id=1bb6bcb2&"
import script from "./RolesView.vue?vue&type=script&lang=js&"
export * from "./RolesView.vue?vue&type=script&lang=js&"
import style0 from "./RolesView.vue?vue&type=style&index=0&id=1bb6bcb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports